import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { OptionsColor } from "../../OptionsColor";
export var LinksShadow = /*#__PURE__*/function () {
  function LinksShadow() {
    _classCallCheck(this, LinksShadow);
    this.blur = 5;
    this.color = new OptionsColor();
    this.enable = false;
    this.color.value = "#00ff00";
  }
  _createClass(LinksShadow, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }
      if (data.blur !== undefined) {
        this.blur = data.blur;
      }
      this.color = OptionsColor.create(this.color, data.color);
      if (data.enable !== undefined) {
        this.enable = data.enable;
      }
    }
  }]);
  return LinksShadow;
}();